import store from '../store'
export default function guest({ next, router }) {
  const tokenLocalStorage = JSON.parse(localStorage.getItem('user'));
  
  if (tokenLocalStorage && tokenLocalStorage.location !== null) {
    return router.push({ name: 'welcome' });
  }
  store.commit('AppModule/setLayout', 'guest');
  return next();
}